import { css, cx } from "@emotion/css"
import { useState, MouseEvent as ReactMouseEvent } from "react"
import Button from "ui/buttons/Button"
import Menu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import { useI18n } from "providers/I18n"
import { operatorOptions } from "."
import { ErrorsMap } from "api/http/utils"
import { FormulaOperator } from "../../GlobalMediaTypes/types"

type Props = {
  disabled: boolean
  handlePartOperandChange: (
    name: string,
    idx: string,
    value?: string | undefined,
  ) => void
  idx: string
  errors?: ErrorsMap
  partOperator?: FormulaOperator
}

export function PartOperatoreMenu(props: Props) {
  const { t } = useI18n()
  const { disabled, errors, handlePartOperandChange, partOperator, idx } = props
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const onOpen = (evt: ReactMouseEvent<HTMLElement>) => {
    setAnchorEl(evt.currentTarget)
  }

  const onClose = () => {
    setAnchorEl(null)
  }

  const onChange = (value?: string) => () => {
    setAnchorEl(null)
    handlePartOperandChange("partOperator", idx, value)
  }

  return !partOperator && disabled ? null : (
    <div className={styles.operatorContainer}>
      <Button
        onClick={onOpen}
        color="primary"
        className={cx(styles.textButton, styles.center)}
        disabled={disabled}
      >
        {!!partOperator
          ? t(`admin.mediaFields.calculated.operation.${partOperator}`)
          : t("admin.mediaFields.calculated.add.operation")}
      </Button>
      <Menu
        id="operator-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        keepMounted
      >
        {operatorOptions(t)?.map((o, oidx) => (
          <MenuItem
            key={oidx}
            onClick={onChange(o.value)}
            classes={{ root: styles.menuItem }}
          >
            {o.label}
          </MenuItem>
        ))}
      </Menu>
      {!!errors?.[`formulaSet.formulaParts[${idx}].partOperator`] ? (
        <p className={styles.errorMessage}>
          {t(errors?.[`formulaSet.formulaParts[${idx}].partOperator`])}
        </p>
      ) : null}
    </div>
  )
}

const styles = {
  operatorContainer: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 70px;
  `,
  textButton: css`
    --btn-padding: 8px;
    --btn-min-width: 0;
    --btn-line-height: 14px;
    --btn-color: inherit;
    --btn-font-weight: normal;
    --btn-bg-hover: transparent;
    --btn-bg-active: transparent;
    --btn-border-color-hover: var(--white);
    --btn-bg-focus-ring-color: transparent;
    width: fit-content;

    &:focus {
      box-shadow: none;
    }

    &[aria-disabled="true"] {
      background-color: transparent;
      color: var(--black);
    }
  `,
  center: css`
    align-self: center;
  `,
  menuItem: css`
    min-height: 38px;
  `,
  errorMessage: css`
    font-size: 13px;
    color: var(--light-red);
  `,
}
